<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    龙井站<br>
站点介绍<br>
龙井站位于龙珠大道与向南的龙珠四路“丁”字交叉口西北侧。北侧由西往东依次是加油站、鼎盛嘉园（两幢高层住宅）深圳市拘留所、深圳市教育收容所和国家工商行政管理总局行政学院。西侧是怡然天地居，东侧为规划绿地及龙井村。龙井站装修以米白色及淡蓝色为主色调，柱面采用搪瓷钢板，现场美观大方，经济适用。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:13	23:48	7号线	3分35秒	5分55秒<br>
太安	06:24	23:09	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:19	23:48	7号线	4分钟	5分55秒<br>
太安	06:29	23:09	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:19	00:48	7号线	4分钟	5分55秒<br>
太安	06:29	00:09	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
B出入口:<br>
龙珠大道南侧、龙珠五路、南汾大厦、龙井村、怡然天地居、深圳法制教育学院、深圳市收容教育所、车辆管理所、西丽驾考中心<br><br>
C出入口:<br>
龙珠大道北侧、国家工商行政管理总局行政学院、十五峰<br><br>
D出入口:<br>
龙珠大道北侧、鼎胜山邻居、南坪快速<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 鼎盛山邻<br>
326路,334路,B710路,M203路,M369路,M474路,N8路,19路,104路,201路,235路,316路,325路,高峰专线62路,高峰专线69路<br><br>
B出入口:<br>
公交站名： 龙珠四路<br>
26路,58路,67路<br><br>
D出入口:<br>
公交站名： 鼎盛山邻<br>
326路,334路,B710路,M203路,M369路,M474路,19路,104路,201路,235路,316路,325路,N8路,高峰专线62路,高峰专线69路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>